import deepCamelizeKeys from "../../../../utils/object/deepCamelizeKeys.js";
import { API_HOST_NAME } from "../constants.js";
import { has } from 'lodash';

const URL = `${API_HOST_NAME}/api/v1/auth/verify_otp`;

const useVerifyOtp = () => {

  const verify = (loginToken, otpCode) => {
    return fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        verification: {
          login_token: loginToken,
          otp_code: otpCode,
        }
      }),
    })
      .then((response) => {
        if (response.status === 401) {
          return Promise.reject(new Error('Invalid verification code'))
        }
        return response.json()
      })
      .then((data) => {
        const body = deepCamelizeKeys(data)

        if (has(body, 'token')) {
          return { type: 'token', token: body.token }
        }
        if (has(body, 'locationConfirmationRequired')) {
          return {
            type: 'locationConfirmationRequired',
            confirmationToken: body.locationConfirmationRequired.confirmationToken,
            message: body.locationConfirmationRequired.message,
          }
        }
        return Promise.reject(new Error('Unknown response format'))
      })
  }

  return { verify };
};

export default useVerifyOtp;
